// Image imports
import kedemFamilyPhoto from '../../../images/siman_tov_family.webp';

export const kedemFamilyMemorial = {
  id: 5,
  name: 'The Kedem Family',
  category: 'families',
  images: {
    family: kedemFamilyPhoto
  },
  info: `

![The Kedem Family](${kedemFamilyPhoto})
*The Kedem family: Tamar, Yonatan, Carol, Shahar, Arbel, and Omer*

"An entire family wiped out by Hamas terrorists. There are no words." - Israel's official Twitter account

## A Horrfying Attack

On October 7, 2023, the Kedem family's lives were tragically cut short during the Hamas terrorist attack on Kibbutz Nir Oz. The family consisted of:

- Tamar Kedem-Siman Tov, 35
- Yonatan (Johnny) Siman Tov
- Carol Siman Tov (Yonatan's mother)
- Shahar and Arbel, 6-year-old twin daughters
- Omer, 4-year-old son

At 2:45 PM on that fateful Saturday, Tamar sent a message to friends in Australia, saying, "Hi guys, we got into the shelter in our house, we're all doing okay." Tragically, just one hour later, Tamar stopped responding to messages. Shortly after, Hamas terrorists entered their shelter and executed the entire family.

## Tamar Kedem-Siman Tov: A Community Leader

Tamar was a remarkable woman with a passion for community service and women's rights. She grew up in Jerusalem and held an MA in Management and Public Policy from Ben-Gurion University. At the time of her death, Tamar was:

- An adviser to the Ministry of the Interior in the Department of Regional Cooperation and Clusters
- Campaigning to head the Eshkol Regional Council in local elections
- A former programme leader at the Cadets for Municipal Service

Her friend, Rotem Abutbul, remembered her as someone who had "a desire to change things" and said, "We always said we'd hear a lot about you, but never imagined that it would be in our worst nightmares."

## Yonatan "Johnny" Siman Tov: A Man of the Land

Yonatan was deeply connected to Kibbutz Nir Oz, where he worked as:

- An operations manager
- A wheat grower

His Facebook page was filled with support for his wife's political campaign, showing his dedication to both his family and community.

## A Family Remembered

The Kedem family was known for their love, warmth, and commitment to their community. Just days before the attack, Tamar had posted pictures on Facebook of her family enjoying Sukkot celebrations, a poignant reminder of the joy that filled their lives.

Their tragic story serves as a stark reminder of the brutality of the October 7 attacks and the innocent lives lost. As we remember the Kedem family, we honor their memory and the impact they had on their community during their all-too-short lives.

May the memory of Tamar, Yonatan, Carol, Shahar, Arbel, and Omer be a blessing. Their light continues to shine in the hearts of those they left behind.

[Read more about the Kedem family](https://www.thejc.com/news/israel/hours-after-mother-told-relatives-she-was-doing-ok-hamas-executed-her-entire-family-xe8pf7lx)

[View the Kedem family memorial page](https://october7memorial.com/memoriam/the-kedem-family)

`
};